import type { AuthorWorkResponse, AuthorWorksListResult } from '../types/author-works.types';

interface AuthorWorksApiPayload {
  fanfics?: AuthorWorkResponse[] | null;
  totalDocs?: number;
  totalPages?: number;
}

export const EMPTY_AUTHOR_WORKS_RESULT: AuthorWorksListResult = {
  fanfics: [],
  totalDocs: 0,
  totalPages: 0,
  hasNextPage: false,
  failed: false,
};

export function normalizeAuthorWorksResponse(
  payload: AuthorWorksApiPayload | null | undefined,
  page: number,
  limit: number,
): AuthorWorksListResult {
  const fanfics = Array.isArray(payload?.fanfics) ? payload.fanfics : [];
  const totalDocs = payload?.totalDocs ?? 0;
  const totalPages = payload?.totalPages ?? (limit > 0 ? Math.ceil(totalDocs / limit) : 0);

  return {
    fanfics,
    totalDocs,
    totalPages,
    hasNextPage: page < totalPages,
    failed: false,
  };
}
